import React, { memo, useCallback } from 'react';
import SpeakerLabelNumberInput from './SpeakerLabelNumberInput';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const SpeakerLabelLineHeightInput = memo(({ value, onChange }: Props) => {
  const handleFormatOutput = useCallback((value: number) => {
    return `${value / 100}`;
  }, []);

  const handleParseInput = useCallback((value: string) => {
    if (!value || value === 'normal' || value === 'none') {
      return 1.3;
    }
    const numValue = parseFloat(value);
    return isNaN(numValue) ? 1.3 : numValue;
  }, []);

  return (
    <SpeakerLabelNumberInput
      value={value}
      onChange={onChange}
      min={50}
      max={200}
      step={5}
      unit="%"
      defaultValue="130"
      testId="line-height-input"
      ariaLabel="Line height percentage (50-200%)"
      incrementLabel="Increase line height"
      decrementLabel="Decrease line height"
      formatOutput={handleFormatOutput}
      parseInput={handleParseInput}
    />
  );
});

export default SpeakerLabelLineHeightInput;
